
<template>
  <div>
    <client-only>
      <Nuxt />
    </client-only>
    <PoweredByLanding />
    <CookieBanner v-if="(areCookieLoaded && !areCookiesConfigured) || cookiesUpdateState" @emitCookieBannerClose="closeCookieBanner" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { getPreferredLanguage } from '~/plugins/language'

export default {
  name: 'Default',
  data () {
    return {
      areCookieLoaded: false,
      areCookiesConfigured: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      program: 'program/getProgramData',
      cookiesUpdateState: 'cookies/getCookiesUpdateState',
    }),
  },
  mounted () {
    this.loadCookiesAndSetStatus()
    const language = getPreferredLanguage()
    this.$i18n.setLocale(language)
  },
  methods: {
    closeCookieBanner () {
      this.areCookiesConfigured = true
      this.$store.commit('cookies/SET_COOKIES_UPDATE_STATE', false)
    },
    loadCookiesAndSetStatus () {
      this.areCookiesConfigured = !!Cookies.get('moderapp_settings')
      setTimeout(() => {
        this.areCookieLoaded = true
      }, 1000)
    },
  },
}
</script>
